// ドライバーの状況。位置や状態が変わるとすぐに読み直す（WebSocket）
import { useCallback, useEffect, useState } from 'react';
import type { DriverStatusRow } from '@torapon/shared';
import { api } from './api';
import { useLive } from './realtime';

export function useDriverStatus() {
  const [rows, setRows] = useState<DriverStatusRow[] | null>(null);
  const reload = useCallback(() => api.get<{ drivers: DriverStatusRow[] }>('/v1/office/drivers/status').then((r) => setRows(r.drivers)).catch(() => {}), []);
  useEffect(() => { void reload(); }, [reload]);
  useLive(['status'], reload);
  return { rows, reload };
}
